import { Box, CircularProgress, Paper } from "@mui/material";
import { useGetServiceDocumentationQuery } from "../../../store/service/serviceSlice";
import { Trans, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import i18next from "i18next";

type AlgorithmProps = {
    serviceName: string;
};

//TODO: Fix proper error handling
const AlgorithmDocumentation = (props: AlgorithmProps): JSX.Element => {

    const { data, error, isLoading, refetch } = useGetServiceDocumentationQuery(props.serviceName, { refetchOnMountOrArgChange: true });
    const { t } = useTranslation();

    i18next.on('languageChanged', function(lng) {
        refetch();
    })

    if(!isLoading) {
        if(data?.documentation != undefined) {
            return (<Paper elevation={2} sx={{px: 2, py: 0, width: '100%', display: 'flex', overflow: 'auto' }} dangerouslySetInnerHTML={{__html: data.documentation}}></Paper>)
        }
        else if(error != undefined && 'data' in error) {
            if(error.status == 404) return (<div><Trans>Requested documentation not found!</Trans> - {error.status} </div>)
            else return (<div>{error.status}</div>)
        }
        else return (<div><Trans>An unexpected error occured!</Trans></div>)
    }
    else {
        return (
            <Box sx={{ p: 2 }}>
                <CircularProgress />
            </Box>)
    }
}

export default AlgorithmDocumentation;